import {Component, Input} from '@angular/core';

interface BreadcrumbItem {
  url?: string;
  title: string;
}

@Component({
  selector: 'breadbrumbs',
  styleUrls: ['./breadcrumb.component.scss'],
  providers: [],
  template: `
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li *ngFor="let item of items" [class.active]="!item?.url" class="breadcrumb-item">
          <a [routerLink]="item?.url">{{item.title}}</a>
        </li>
      </ol>
    </nav>
  `,
})
export class BreadcrumbComponent {
  @Input()
  items: BreadcrumbItem[] = [];
}
